import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input, OnChanges,
    OnDestroy,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { bindFunctionsToThis, isNullOrUndefined } from '../../extensions';

@Component({
    selector: 'ig-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SelectComponent,
            multi: true
        }
    ],
})
export class SelectComponent implements ControlValueAccessor, AfterViewInit, OnDestroy {
    private _value: { text: string, value: string | number, selected: boolean }[];
    private _notifyChange: any;

    public isShowing = false;
    public formGroup: FormGroup;
    public fieldValue: string;
    @Input() public label: string;
    @Input() public disabled: boolean;
    @Input() place: 'top' | 'bottom' = 'bottom';
    @Input() align: 'left' | 'right' = 'left';
    @Input() icon = 'expand_more';
    @Input() public showDropDownItem: string;
    // @Input() public items: {
    //     text: string,
    //     value: string,
    //     selected: boolean,
    //     hide: boolean
    // }[];
    @Output() itemSelected = new EventEmitter<any>();
    @Output() onOpen = new EventEmitter<any>();
    @ViewChild('trigger') trigger: any;
    @ViewChild('container') container: ElementRef;

    constructor(private formBuilder: FormBuilder,) {
        bindFunctionsToThis(this);
        this.formGroup = this.formBuilder.group({
            'input': [null, [Validators.required]],
        });
    }

    public ngAfterViewInit() {
        setTimeout(() => {
            this.bindEvents();
            this.value = this.value.filter(x => isNullOrUndefined(x.hide) || x.hide === false);
            let selected = this.value.first(x => x.selected);
            if (selected) {
                this.fieldValue = selected.text;
            }
        }, 500);
    }

    public get value() {
        return this._value ? this._value.filter(x => !!x) : undefined;
    }

    public set value(newValue: any) {
        if (newValue === this._value || (isNullOrUndefined(this._value) && isNullOrUndefined(newValue))) {
            return;
        }

        this._value = newValue;

        if (this._notifyChange) {
            this._notifyChange(newValue);
        }
    }

    public writeValue(newValue: any): void {
        this._value = newValue;
    }

    public registerOnChange(fn: any): void {
        this._notifyChange = fn;
    }

    public registerOnTouched(fn: any): void {

    }

    public ngOnDestroy() {
        this.unbindEvents();
    }

    public setSelected(value) {
        let selected = this.value.first(x => x.value === value);
        if (selected) {
            this.value.forEach(x => x.selected = false);
            selected.selected = true;
            this.fieldValue = selected.text;
        }
    }

    public select(value) {
        this.itemSelected.emit(value);
        this.fieldValue = value.text;
        this.trigger.input.nativeElement.focus();
        setTimeout(() => {
            this.close();
        });
    }

    private bindEvents() {
        window.addEventListener('click', this.close);
        this.trigger.input.nativeElement.addEventListener('click', this.show);
    }

    private unbindEvents() {
        window.removeEventListener('click', this.close);
        this.trigger.input.nativeElement.removeEventListener('click', this.show);
    }

    public close(event?: Event) {
        if (!event) {
            this.isShowing = false;

            return;
        }

        let parentNode = (event.target as any).parentNode;

        while (parentNode != null && parentNode !== this.container.nativeElement) {
            parentNode = parentNode.parentNode;
        }

        this.isShowing = (parentNode === this.container.nativeElement) || (event.target as any).textContent === 'expand_more'
    }

    private show(event: Event) {
        if (this.disabled) {
            return;
        }
        if (this.showDropDownItem === 'false') {
            this.itemSelected.emit();
            return;
        }
        this.onOpen.emit();
        event && event.stopPropagation();
        let dropDownGap = this.label ? 18 : 10;
        let container = this.container.nativeElement;
        let containerRect = container.getBoundingClientRect();
        let triggerRect = this.trigger.input.nativeElement.getBoundingClientRect();
        let top = triggerRect.height + dropDownGap;
        let left = 0;

        if (this.place === 'top') {
            top = -containerRect.height - dropDownGap;
        }

        if (this.align === 'right') {
            left = triggerRect.right - containerRect.width;
        }

        this.isShowing = true;
        container.style.left = `${left}px`;
        container.style.top = `${top}px`;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/select/select.component.ts